<table class="table table-hover table-striped">
  <thead>
    <tr>
      <ng-container *ngFor="let column of columns">
        <th scope="col" *ngIf="column.sortable" [attr.title]="column.name" [ngClass]="column.classes">
          <app-data-grid-header [sortable]="column.property" [direction]="sortedColumn?.column === column.property ? sortedColumn.direction : ''" (sort)="sort($event)" [title]="column.name"></app-data-grid-header>
        </th>
        <th scope="col" *ngIf="!column.sortable" [attr.title]="column.name" [ngClass]="column.classes">{{ column.name }}</th>
      </ng-container>
    </tr>
  </thead>
  <tbody>
    <ng-container *ngIf="(error$ | async) !== null; else noError">
      <tr class="loadError">
        <td [attr.colspan]="columns.length">
          <app-error-message [errorType]="errorType" [error]="error$ | async"></app-error-message>
        </td>
      </tr>
    </ng-container>
    <ng-template #noError>
      <ng-container *ngIf="(loading$ | async) === false; else loading">
        <ng-container *ngIf="(entities$ | async)?.data?.length; else empty">
          <tr *ngFor="let entity of (entities$ | async)?.data">
            <td *ngFor="let column of columns" [ngClass]="column.classes">
              <app-data-grid-cell [column]="column" [entity]="entity"></app-data-grid-cell>
            </td>
          </tr>
        </ng-container>
        <ng-template #empty>
          <tr class="empty">
            <td [attr.colspan]="columns.length">
            <app-data-grid-empty-table [name]="entityName" [link]="createUrl"></app-data-grid-empty-table>
            </td>
          </tr>
        </ng-template>
      </ng-container>
      <ng-template #loading>
        <tr>
          <td [attr.colspan]="columns.length">
            <app-loading-icon [text]="'Loading ' + entityName + 's'" size="lg"></app-loading-icon>
          </td>
        </tr>
      </ng-template>
    </ng-template>
  </tbody>
  <tfoot>
    <tr>
      <td [attr.colspan]="columns.length">
        <ngb-pagination class="d-flex justify-content-center" [page]="(entities$ | async)?.pagination?.currentPage" [pageSize]="(entities$ | async)?.pagination?.pageSize" [collectionSize]="(entities$ | async)?.pagination?.totalCount || 1" (pageChange)="goToPage($event)"></ngb-pagination>
      </td>
    </tr>
  </tfoot>
</table>
